import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-nav-controls-mobile',
  templateUrl: './controls-mobile.component.html',
  styleUrls: ['./controls-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
  ],
})
export class ControlsMobileComponent {
  @Input() public isOpen!: boolean | null;
  @Input() public isExpanded!: boolean | null;

  @Output() public switchOpen: EventEmitter<void> = new EventEmitter<void>();
  @Output() public collapse: EventEmitter<void> = new EventEmitter<void>();
}
